import styles from './ProgressBar.module.css';

interface ProgressBarProps {
  percent: number;
  label?: string;
}

export function ProgressBar({percent, label}: ProgressBarProps) {
  return (
    <div>
      <div className={styles.track}>
        <div
          className={styles.fill}
          style={{width: `${Math.min(100, Math.max(0, percent))}%`}}
        />
      </div>
      {label && <div className={styles.label}>{label}</div>}
    </div>
  );
}
